import { Tabs } from "@mui/material";
import { styled } from "@mui/system";

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.success.dark,
  },
  "& .MuiButtonBase-root": {
    color: theme.palette.success.dark,
    fontWeight: "normal",
    textTransform: "none",

    "&.Mui-selected": {
      color: theme.palette.success.dark,
      borderBottom: `2px solid ${theme.palette.success.dark}`,
      "& p": {
        fontWeight: "bold",
      },
    },
  },
  "& .MuiTab-root": {
    borderBottom: "2px solid #DFE4DD", // Grey line for unselected tabs
    transition: "border-color 0.3s ease",
  },
}));
